import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../../App.css";
import BlogPostView from "./BlogPostView";

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    const loadPost = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await fetch(`/api/blog/posts/${encodeURIComponent(slug)}`, {
          credentials: "include",
          cache: "no-store",
        });

        const payload = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error(payload?.error || "Unable to load blog post");
        }

        if (mounted) setPost(payload);
      } catch (err) {
        if (mounted) setError(err.message || "Unable to load blog post");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    loadPost();

    return () => {
      mounted = false;
    };
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-shell">
        <div className="blog-panel">
          <p className="blog-loading">Loading post...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-shell">
        <div className="blog-panel">
          <div className="blog-kicker">BLOG</div>
          <h1 className="blog-title">Post unavailable</h1>
          <p className="blog-error">{error}</p>
          <Link to="/blog" className="blog-button">Back to Blog</Link>
        </div>
      </div>
    );
  }

  return <BlogPostView post={post} />;
};

export default BlogPostPage;
